// Studyo Today Backend
// Package studyo.today.type
// Resource definitions
// Copyright (c) 2015-2020 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/type/client_app_kind.proto (package studyo.today.type, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/type/client_app_kind.proto.
 */
export const file_studyo_today_type_client_app_kind = /*@__PURE__*/
  fileDesc("CidzdHVkeW8vdG9kYXkvdHlwZS9jbGllbnRfYXBwX2tpbmQucHJvdG8SEXN0dWR5by50b2RheS50eXBlKn8KDUNsaWVudEFwcEtpbmQSHwobQ0xJRU5UX0FQUF9LSU5EX1VOU1BFQ0lGSUVEEAASFwoTQ0xJRU5UX0FQUF9LSU5EX1dFQhABEhcKE0NMSUVOVF9BUFBfS0lORF9JT1MQAhIbChdDTElFTlRfQVBQX0tJTkRfQU5EUk9JRBADQhmqAhZTdHVkeW8uVG9kYXkuR3JwYy5UeXBlYgZwcm90bzM");

/**
 * Describes the enum studyo.today.type.ClientAppKind.
 */
export const ClientAppKindSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_type_client_app_kind, 0);

/**
 * Represents the kind of client app that is interacting with the Today API.
 *
 * @generated from enum studyo.today.type.ClientAppKind
 */
export const ClientAppKind = /*@__PURE__*/
  tsEnum(ClientAppKindSchema);

